import React, { useState } from 'react';
import debugAuth from '@/utils/debugAuth';

/**
 * AuthDebugger - Component for debugging authentication issues
 * Only shows in development mode
 */
function AuthDebugger() {
  const [debugInfo, setDebugInfo] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  // Only show in development
  if (import.meta.env.NODE_ENV !== 'development') {
    return null;
  }

  const handleCheckAuth = async () => {
    const session = await debugAuth.checkAuthState();
    setDebugInfo(JSON.stringify(session, null, 2));
  };

  const handleLogTokens = () => {
    debugAuth.logCognitoTokens();
    setDebugInfo('Check console for token information');
  };

  const handleClearAuth = () => {
    debugAuth.clearAllAuthData();
    setDebugInfo('All auth data cleared');
  };

  if (!isVisible) {
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <button
          onClick={() => setIsVisible(true)}
          className="bg-red-500 text-white px-3 py-1 rounded text-xs"
        >
          🐛 Auth Debug
        </button>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-4 max-w-md">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-bold text-sm">Auth Debugger</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </div>
      
      <div className="space-y-2 mb-3">
        <button
          onClick={handleCheckAuth}
          className="w-full bg-blue-500 text-white px-3 py-1 rounded text-xs"
        >
          Check Auth State
        </button>
        
        <button
          onClick={handleLogTokens}
          className="w-full bg-green-500 text-white px-3 py-1 rounded text-xs"
        >
          Log Tokens
        </button>
        
        <button
          onClick={handleClearAuth}
          className="w-full bg-red-500 text-white px-3 py-1 rounded text-xs"
        >
          Clear Auth Data
        </button>
      </div>
      
      {debugInfo && (
        <div className="bg-gray-100 p-2 rounded text-xs max-h-40 overflow-auto">
          <pre>{debugInfo}</pre>
        </div>
      )}
    </div>
  );
}

export default AuthDebugger;
